const translations = {
  en: {
    translation: {
      youAreWatching: "You're watching",
      paused: 'Paused',
      tryAccessingOtherQuality: 'Try changing the image quality',
      goBack: 'Close',
      speeds: 'Speed',
      nextEpisode: 'Next Episode',
      playlist: 'Playlist',
      playError: 'Something went wrong playing this video',
    },
  },
  pt: {
    translation: {
      youAreWatching: 'Você está assistindo',
      paused: 'Pausado',
      tryAccessingOtherQuality: 'Tente acessar por outra qualidade',
      goBack: 'Fechar',
      speeds: 'Velocidades',
      nextEpisode: 'Próximo Episódio',
      playlist: 'Lista de Reprodução',
      playError: 'Ocorreu um erro ao tentar reproduzir este vídeo -_-',
    },
  },
};

export default translations;
